/* eslint-disable no-unused-vars */

import { Box, List, styled } from '@mui/material';
import { generalmenuItems, managementMenuItems } from './items';
import { managementLink, playbackLinks, recordLink, routeList } from '../../../../router/routerLink';
import { matchPath, useLocation } from 'react-router-dom';

import React from 'react';
import SidebarMenuItem from './SidebarMenuItem';

const MenuWrapper = styled(Box)(
  ({ theme }) => `
  .MuiList-root {
    padding: ${theme.spacing(1)};

    & > .MuiList-root {
      padding: 0 ${theme.spacing(0)} ${theme.spacing(1)};
    }
  }

    .MuiListSubheader-root {
      text-transform: uppercase;
      font-weight: bold;
      font-size: ${theme.typography.pxToRem(12)};
      color: ${theme.colors.alpha.trueWhite[50]};
      padding: ${theme.spacing(0, 2.5)};
      line-height: 1.4;
    }
`
);

const SubMenuWrapper = styled(Box)(
  ({ theme }) => `
    .MuiList-root {

      .MuiListItem-root {
        padding: 2px 0;
        .MuiBadge-root {
          position: absolute;
          right: ${theme.spacing(3.2)};

          .MuiBadge-standard {
            background: ${theme.colors.primary.main};
            font-size: ${theme.typography.pxToRem(10)};
            font-weight: bold;
            text-transform: uppercase;
            color: ${theme.palette.primary.contrastText};
          }
        }
    
        .MuiButton-root {
          display: flex;
          color: ${theme.colors.alpha.trueWhite[70]};
          background-color: transparent;
          width: 100%;
          justify-content: flex-start;
          padding: 5px;

          .MuiButton-startIcon,
          .MuiButton-endIcon {
            transition: ${theme.transitions.create(['color'])};

            .MuiSvgIcon-root {
              font-size: inherit;
              transition: none;
            }
          }

          .MuiButton-startIcon {
            color: ${theme.colors.alpha.trueWhite[30]};
            font-size: ${theme.typography.pxToRem(20)};
            margin-right: ${theme.spacing(1)};
          }
          
          .MuiButton-endIcon {
            color: ${theme.colors.alpha.trueWhite[50]};
            margin-left: auto;
            opacity: .8;
            font-size: ${theme.typography.pxToRem(20)};
          }
          &.Mui-active,
          &:active {
            color: #FFFFFF;
          }
          &.Mui-active,
          &:hover {
            color: #E6E7EB;
            .MuiButton-startIcon,
            .MuiButton-endIcon {
              color: ${theme.colors.alpha.trueWhite[100]};
            }
          }
        }
      
        &.Mui-children {
          flex-direction: column;

          .MuiBadge-root {
            position: absolute;
            right: ${theme.spacing(7)};
          }
        }

        .MuiCollapse-root {
          width: 100%;

          .MuiList-root {
            padding: ${theme.spacing(1, 0)};
          }

          .MuiListItem-root {
            padding: 1px 0;

            .MuiButton-root {
              padding: ${theme.spacing(0.8, 3)};

              .MuiBadge-root {
                right: ${theme.spacing(3.2)};
              }

              &:before {
                content: ' ';
                background: ${theme.colors.alpha.trueWhite[100]};
                opacity: 0;
                transition: ${theme.transitions.create([
    'transform',
    'opacity'
  ])};
                width: 6px;
                height: 6px;
                transform: scale(0);
                transform-origin: center;
                border-radius: 20px;
                margin-right: ${theme.spacing(1.8)};
              }

              &.Mui-active,
              &:hover {

                &:before {
                  transform: scale(1);
                  opacity: 1;
                }
              }
            }
          }
        }
      }
    }
`
);

const checkMatchRoute = ( path, linksList) => {
  let isRoute = false;
  let hasRoute = false;
  linksList.forEach(p=> {
    const match = matchPath({
    path: p,
    end: true
  }, path)
  if(match){
    hasRoute = true;
  }
});
if(hasRoute){
  isRoute=true;
}
return isRoute;
}

const renderSidebarMenuItems = ({ items, path }) => (
  <>
    <SubMenuWrapper>
      <List component="div">
        {items.reduce((ev, item) => reduceChildRoutes({ ev, item, path }), [])}
      </List>
    </SubMenuWrapper>
  </>
);

const reduceChildRoutes = ({ ev, path, item }) => {
  const key = item.name;

  const exactMatch = item.link
    ? !!matchPath(
      {
        path: item.link,
        end: true
      },
      path
    )
    : false;
  if (item.items) {
   
    const partialMatch = item.link
      ? !!matchPath(
        {
          path: item.link,
          end: false
        },
        path
      )
      : false;
    ev.push(
      <SidebarMenuItem
        key={key}
        active={partialMatch}
        open={partialMatch}
        name={item.name}
        icon={item.icon}
        image={item.image}
        hoverImage={item.hoverImage}
        selectedImage={item.selectedImage}
        alt={item.alt}
        link={item.link}
        badge={item.badge}
      >
        {renderSidebarMenuItems({
          path,
          items: item.items
        })}
      </SidebarMenuItem>
    );
  } else {
    let isRoute=false;
    if(item.link == managementLink){
      isRoute = checkMatchRoute( path, routeList)
    }
    if(item.link == recordLink){
      isRoute = checkMatchRoute(path, playbackLinks)
    }
    ev.push(
      <SidebarMenuItem
        key={key}
        active={isRoute? true : exactMatch}
        name={item.name}
        link={item.link}
        badge={item.badge}
        icon={item.icon}
        image={item.image}
        hoverImage={item.hoverImage}
        selectedImage={item.selectedImage}
        alt={item.alt}
      />
    );
  }

  return ev;
};

export function GeneralSidebarMenu() {
  const location = useLocation();

  return (
    <>
      {generalmenuItems.map((section) => (
        <MenuWrapper key={section.heading}>
          <List
            component="div"
          >
            {renderSidebarMenuItems({
              items: section.items,
              path: location.pathname
            })}
          </List>
        </MenuWrapper>
      ))}
    </>
  );
}

export function ManagementSidebarMenu() {
  const location = useLocation();
  return (
    <>
      {managementMenuItems.map((section) => {
        return (
          <MenuWrapper key={section.heading}>
            <List
              component="div"
            >
              {renderSidebarMenuItems({
                items: section.items,
                path: location.pathname
              })}
            </List>
          </MenuWrapper>
        );
      })}
    </>
  );
}


